// extracted by mini-css-extract-plugin
export var cancelButton = "StockTakeSheetSelect-module--cancelButton--a6rYB";
export var thumbnail = "StockTakeSheetSelect-module--thumbnail--cQU5Z";
export var thumbnailBadge = "StockTakeSheetSelect-module--thumbnailBadge--CDg8V";